module.exports = __webpack_public_path__ + "media/Desktop_loss.2c11193d.webm";